<div>
  <mat-icon aria-hidden="false" class="alarm">error</mat-icon>
</div>
